module.exports = __webpack_public_path__ + "static/media/session4grayscale.2e5cb6b6.svg";